import angular from "angular";

angular
    .module('app')
    .component('demoSignUp', {
        template: require('./demo-sign-up.html'),
        controller: ['$http', 'Notifier', 'trans','$timeout', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, trans,$timeout) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
    };

    $ctrl.confirm = function () {
        $ctrl.loading = false;
        $http
            .post(`/courses/${$ctrl.course.id}/demo-sign-up`)
            .then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success(trans('Success signed up for course'), 3);

                    $timeout(function () {
                        window.location = `/cabinet/courses/${$ctrl.course.id}/`;
                    }, 3000);

                    $ctrl.close();


                },
                function (error) {
                    $ctrl.loading = false;
                }
            )
    }

}
